import { Field, FieldError, FieldLabel } from "@/client/components/shad/field";

import { useFieldContext } from "../form-context";

import { Button, Group, NumberField, Input } from "react-aria-components";
import { IconMinus, IconPlus } from "@tabler/icons-react";
import { useId } from "react";

type Props = {
  min?: number;
  max?: number;
  step?: number;
  label: string;
};

export function NumberSelectField({
  label,
  max = 100,
  min = 0,
  step = 1,
}: Props) {
  const field = useFieldContext<number>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;
  const id = useId();
  return (
    <Field>
      <NumberField
        aria-label={label}
        maxValue={max}
        minValue={min}
        step={step}
        onChange={field.handleChange}
        value={Number(field.state.value)}
      >
        <div className="*:not-first:mt-2">
          <FieldLabel htmlFor={id}>{label}</FieldLabel>
          <Group className="relative inline-flex h-9 w-full items-center overflow-hidden whitespace-nowrap rounded-md border border-input text-sm shadow-xs outline-none transition-[color,box-shadow] data-focus-within:border-ring data-disabled:opacity-50 data-focus-within:ring-[3px] data-focus-within:ring-ring/50 data-focus-within:has-aria-invalid:border-destructive data-focus-within:has-aria-invalid:ring-destructive/20 dark:data-focus-within:has-aria-invalid:ring-destructive/40">
            <Button
              className="-ms-px flex aspect-square h-[inherit] items-center justify-center disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50"
              slot="decrement"
            >
              <IconMinus aria-hidden="true" size={16} />
            </Button>
            <Input
              id={id}
              className="w-full grow border-x px-3 py-2 text-center tabular-nums"
            />
            <Button
              className="-me-px flex aspect-square h-[inherit] items-center justify-center transition-[color,box-shadow] "
              slot="increment"
            >
              <IconPlus aria-hidden="true" size={16} />
            </Button>
          </Group>
        </div>
      </NumberField>
      {isInvalid && (
        <FieldError className="text-xs" errors={field.state.meta.errors} />
      )}
    </Field>
  );
}
